import React from 'react';
import PropTypes from 'prop-types';

import { downloadFile } from '../../utils/download';
import ButtonsList from '../ButtonsList';

import { DownloadWrapper } from './styles';
import { formatDate } from '../../utils/date';

const DownloadComponent = ({
  columns, items, selected, title, fileName, fontSize, buttonTitle, width,
}) => {
  const downloadSelected = type => async () => {
    const selectedItems = items.filter(item => selected.includes(item.id)).map((item) => {
      const flightDate = formatDate(item.flightDate, 'YYYY/MM/DD');
      const { carrier } = item;
      let { origin = [], destination = [] } = item;
      origin = origin.join(', ');
      destination = destination.join(', ');

      if (carrier && carrier.label) {
        const braceIndex = carrier.label.indexOf('(');
        carrier.label = braceIndex === -1 ? carrier.label : carrier.label.substr(0, braceIndex - 1);
      }

      return {
        ...item, flightDate, origin, destination, carrier,
      };
    });

    const filteredColumns = columns.filter(column => !column.exclude || !column.exclude.includes(type));
    const options = {
      columns: filteredColumns, fileName, title, fontSize,
    };

    await downloadFile(type, selectedItems, options);
  };

  return (
    <DownloadWrapper>
      <ButtonsList title={buttonTitle || 'Download'} width={width || '140px'} overlap disabled={!selected.length}>
        <div id="download-excel" onClick={downloadSelected('excel')}>Excel</div>
        <div onClick={downloadSelected('csv')}>CSV</div>
        <div onClick={downloadSelected('pdf')}>PDF</div>
      </ButtonsList>
    </DownloadWrapper>
  );
};

DownloadComponent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape),
  selected: PropTypes.arrayOf(PropTypes.number),
  columns: PropTypes.arrayOf(PropTypes.shape),
  title: PropTypes.string,
  buttonTitle: PropTypes.string,
  fileName: PropTypes.string,
  width: PropTypes.string,
  fontSize: PropTypes.number,
};

export default DownloadComponent;
